import { render } from "./Top.vue?vue&type=template&id=04c6c6b6&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "./Top.vue?vue&type=style&index=0&id=04c6c6b6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c6c6b6"]])

export default __exports__